import React from 'react'
import { getMenuIconDef, getMenuLucideIcon } from '../lib/menu/menuIcons'
import { getMenuSvgAsset } from '../lib/menu/menuIconAssets'

/**
 * @param {{ menuItemId?: string, emoji?: string, className?: string, size?: number }} props
 */
export default function MenuIcon({ menuItemId, emoji, className = '', size = 18 }) {
  const def = getMenuIconDef(menuItemId)
  const svgAsset = getMenuSvgAsset(def?.appIconKey)
  const Lucide = getMenuLucideIcon(menuItemId)
  if (svgAsset) {
    return (
      <img
        src={svgAsset}
        alt=""
        className={`inline-flex shrink-0 object-contain ${className}`}
        style={{ width: size, height: size }}
        aria-hidden="true"
      />
    )
  }
  if (def?.icon) {
    return <Lucide className={className} size={size} strokeWidth={1.75} aria-hidden="true" />
  }
  if (emoji) {
    return <span className={`inline-flex shrink-0 items-center justify-center text-base leading-none ${className}`} aria-hidden="true">{emoji}</span>
  }
  return <Lucide className={className} size={size} strokeWidth={1.75} aria-hidden="true" />
}
